/**
 * Os anexos presos acima da caixa do chat (BRAZ-26) saem em ordem, um por vez, e a legenda (o texto
 * digitado) vai com o primeiro que sair. O envio que falha (passou do limite do plano, a rede caiu)
 * não leva a legenda: ela segue para o próximo anexo.
 *
 * `send` diz se o anexo saiu; `done` tira cada um de cima da caixa quando acaba, tenha saído ou não.
 * Devolve a legenda que não foi com nenhum (todos falharam), para quem chama não a perder.
 */
export async function sendAttachments<T>(items: readonly T[], caption: string, send: (item: T, caption: string) => Promise<boolean>, done: (item: T) => void): Promise<string> {
  let pending = caption;
  for (const item of items) {
    if (await send(item, pending)) pending = '';
    done(item);
  }
  return pending;
}
